import { CodeIcon } from '@heroicons/react/solid';
import React, { useState } from 'react';
import { projects } from '../../data';
import resume from '../../images/Resume.pdf';

export default function Projects() {
  const [selectedTags, setSelectedTags] = useState('ALL');
  const allTags = ['ALL', ...new Set(projects.flatMap(project => project.tags))];

  const filteredProjects = selectedTags === 'ALL'
  ? projects
  : projects.filter(project => project.tags.includes(selectedTags));

  return (
    <section id="projects" className="text-gray-400 bg-gray-900 body-font">
      <div className="container px-5 py-10 mx-auto text-center lg:px-40">
        <div className="flex flex-col w-full mb-10">
          <CodeIcon className="inline-block w-10 mx-auto mb-4" />
          <h1 className="mb-4 text-3xl font-medium text-white sm:text-4xl title-font">
            Apps I've Built
          </h1>
          <p className="mx-auto text-base leading-relaxed lg:w-2/3">
            These are some demos from projects I made or I was part of. Check
            <a
              className="font-semibold leading-relaxed text-indigo-400"
              href="https://github.com/daadaamed"
            >
              {' '}
              my GitHub account
            </a>{' '}
            or
            <a
              className="font-semibold leading-relaxed text-indigo-400"
              href={resume}
              attributes-list
              download="Resume"
            >
              {' '}
              my resume
            </a>{' '}
            for more details. Click any project to see its code source on GitHub.
          </p>
        </div>
        <div className="container px-5 mx-auto text-center lg:px-40">
          <div className='mb-5'>
            <select
              className='p-2 text-white bg-gray-800'
              value={selectedTags}
              onChange={(e)=>setSelectedTags(e.target.value)}
            >
              {allTags.map(tag=> (
                <option key={tag} value={tag}>{tag}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="flex flex-wrap -m-4">
          {filteredProjects.map((project) => (
            <a
              href={project.link}
              key={project.image}
              className="w-full p-4 sm:w-1/2"
            >
              <div className="relative flex h-80">
                <img
                  alt="gallery"
                  className="absolute inset-0 object-cover object-center w-full h-full display-flex"
                  src={project.image}
                />
                <div className="relative w-full px-8 py-10 overflow-y-auto bg-gray-900 border-4 border-gray-800 opacity-0 hover:opacity-100 max-h-80">
                  <h2 className="mb-1 text-sm font-medium tracking-widest text-green-400 title-font">
                    {project.subtitle}
                  </h2>
                  <h1 className="mb-3 text-lg font-medium text-white title-font">
                    {project.title}
                  </h1>
                  <p className="leading-relaxed">{project.description}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
